export default "__VITE_ASSET__vYzL9oVtLmfR$5RMIYkFWQ__"